// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.borderBottom(BrowserStyle.px(1), "solid", {
            TAG: /* Grey */2,
            _0: /* Light */3
          }),
      tl: /* [] */0
    });

function arg(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XLarge */5, /* Bold */2);
}

var title = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
          hd: BrowserStyle.flex({
                NAME: "num",
                VAL: 1.0
              }),
          tl: /* [] */0
        }));

var description = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Medium */3, undefined)(/* [] */0));

var Styles = {
  container: container,
  title: title,
  description: description
};

function WebComponents_SettingsTabHeader(Props) {
  var addButtonClick = Props.addButtonClick;
  var addButtonText = Props.addButtonText;
  var description$1 = Props.description;
  var title$1 = Props.title;
  return React.createElement(BrowserComponents_FlexColumn.make, {
              className: container,
              children: null
            }, React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_FlexRow.make, {
                  children: null
                }, React.createElement(BrowserComponents_Text.make, {
                      className: title,
                      children: title$1
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    }), React.createElement(BrowserComponents_Button.make, {
                      actionPriority: /* Primary */0,
                      onClick: (function (param) {
                          return addButtonClick;
                        }),
                      size: /* Small */0,
                      testId: "add" + (Relude_String.removeEach("-", Relude_String.removeEach(" ", title$1)) + "Button"),
                      title: addButtonText
                    })), Relude_Option.fold(null, (function (desc) {
                    return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Medium */4
                                  }), React.createElement(BrowserComponents_Text.make, {
                                    className: description,
                                    children: desc
                                  }));
                  }), description$1), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Large */5
                }));
}

var make = WebComponents_SettingsTabHeader;

exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
